import React, { useState, useEffect, useMemo } from 'react';
import styles from './featuresModal.module.scss';
import { Box, Typography, Chip, ThemeProvider, createTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import FeaturesModal from './FeaturesModal';
import { FeaturesListProps } from '../../../interfaces/salePost';

// Crear un tema personalizado con la fuente de la aplicación
const theme = createTheme({
  typography: {
    fontFamily: '"LTSaeada", "Roboto", sans-serif',
    subtitle1: {
      fontWeight: 500
    },
    body2: {},
  },
  components: {
    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: '"LTSaeada", "Roboto", sans-serif',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#7100FF',
        },
        contained: {
          backgroundColor: '#7100FF',
          '&:hover': {
            backgroundColor: '#5c00d6',
          },
        },
      },
    },
  },
});

function FeaturesList({
  selectedFeatures,
  getAdditionalCharacters,
  additionalCharacters,
  setAdditionalCharacters,
  setSelectedAdditionalCharacters,
}: FeaturesListProps) {
  const [modalOpen, setModalOpen] = useState(false);
  console.log("📦 selectedFeatures (chips):", selectedFeatures);

  useEffect(() => {
    if (!additionalCharacters || additionalCharacters.length === 0) {
      getAdditionalCharacters?.();
    }
  }, [additionalCharacters, getAdditionalCharacters]);

  const getFeatureName = (featureId: string): string => {
    for (const category of additionalCharacters || []) {
      const feature = category.value.find((item: any) => item.code === featureId);
      if (feature) return feature.name;
    }
    return featureId;
  };

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  const handleSaveFeatures = (selectedIds: string[]) => {
    const selectedArray = [];

    for (const category of additionalCharacters || []) {
      const selectedValues = category.value.filter((item: any) => selectedIds.includes(item.code))
        .map((item: any) => ({
          name: item.name,
          code: item.code,
          value: true
        }));

      if (selectedValues.length > 0) {
        selectedArray.push({
          name: category.name,
          code: category.code,
          value: selectedValues
        });
      }
    }

    console.log("✅ Características seleccionadas:", selectedArray);
    setSelectedAdditionalCharacters(selectedArray);
  };

  const handleRemoveFeature = (featureId: string) => {
    const updated = selectedFeatures.map((cat: any) => ({
      ...cat,
      value: cat.value.filter((item: any) => item.code !== featureId)
    })).filter((cat: any) => cat.value.length > 0);
  
    setSelectedAdditionalCharacters(updated);
  };
  
  const selectedFeatureIds = useMemo(() => {
    return selectedFeatures.flatMap((category: any) =>
      (category.value || [])
        .filter((item: any) => item.value === true)
        .map((item: any) => item.code)
    );
  }, [selectedFeatures]);
  console.log("🚀 selectedFeatureIds:", selectedFeatures);
  
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ mt: 2 }}>
        <div className={styles.addFeaturesHeader}>
          <Typography variant="subtitle1">
            Características adicionales
          </Typography>
          <button
            className={styles.addFeaturesButton}
            onClick={handleOpenModal}
          >
            <AddIcon className={styles.addIcon} />
            Añadir características
          </button>
        </div>

        <div className={styles.featuresList}>
        {selectedFeatureIds.length > 0 &&
  selectedFeatureIds.map((featureId) => (
    <Chip
      key={featureId}
      label={getFeatureName(featureId)}
      onDelete={() => handleRemoveFeature(featureId)}
      className={styles.featureChip}
      deleteIcon={<CloseIcon style={{ fontSize: '16px' }} />}
      sx={{
        margin: '0 4px 4px 0',
        height: '28px',
        color: 'rgba(115, 115, 115, 1)',
      }}
    />
  ))}

        </div>

        <FeaturesModal
          open={modalOpen}
          onClose={handleCloseModal}
          initialSelectedFeatures={selectedFeatures}
          additionalCharacters={additionalCharacters}
          setAdditionalCharacters={setAdditionalCharacters}
          setSelectedAdditionalCharacters={setSelectedAdditionalCharacters}
          selectedAdditionalCharacters={selectedFeatures}
        />

      </Box>
    </ThemeProvider>
  );
}

export default FeaturesList;
